var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"qb-sticky",style:(_vm.width!='' ? {width:`${_vm.width}`}:''),on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),(_vm.sortType == 'ASC')?_c('span',{staticClass:"material-icons sm-size"},[_vm._v("keyboard_arrow_up")]):_c('span',{staticClass:"material-icons sm-size"},[_vm._v("keyboard_arrow_down")])])
}
var staticRenderFns = []

export { render, staticRenderFns }